"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadWriteLock = void 0;
const async_mutex_1 = require("async-mutex");
class ReadWriteLock {
    readMutex = new async_mutex_1.Mutex();
    writeMutex = new async_mutex_1.Mutex();
    blockingReaders = 0;
    async acquireRead(func) {
        let release;
        await this.readMutex.runExclusive(async () => {
            this.blockingReaders++;
            if (this.blockingReaders === 1) {
                release = await this.writeMutex.acquire();
            }
        });
        try {
            return await func();
        }
        finally {
            await this.readMutex.runExclusive(() => {
                this.blockingReaders--;
                if (this.blockingReaders === 0) {
                    release();
                }
            });
        }
    }
    async acquireWrite(func) {
        await this.writeMutex.runExclusive(func);
    }
}
exports.ReadWriteLock = ReadWriteLock;
